import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/569acf4b665be3c5b78a1d2126b09cab.png"
            alt="About Hero"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/30"></div>
        </div>
        
        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl md:text-6xl font-light text-white tracking-tight">About</h1>
          <p className="text-xl text-white/90 mt-4 font-light">Award-winning Screenwriter &amp; Author</p>
        </div>
      </section>

      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          {/* Brief Biography Section */}
          <section className="mb-20">
            <h2 className="text-3xl font-light text-black mb-8 tracking-tight">Pamela Stovall Brief Biography</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Pamela Stovall is an award-winning screenwriter, writer and the author of four books.
              </p>
              <p>
                Her scripts have received numerous honors, such as Top 10 percent in the Austin Film Festival; a Semi-Finalist at Page International Screenwriting Awards; and two scripts won the Spirit of Moondance Award from the Moondance International Film Festival.
              </p>
              <p>
                Her work as a volunteer fire fighter inspired her to write the drama TV pilot FINDING JOY, about a self-destructive female fire chief who's trying to find her missing daughter. FINDING JOY is currently under a shopping agreement with Bohemia Entertainment thanks to an introduction by Roadmap Writers.
              </p>
              <p>
                Pamela also volunteered to teach writing at a New Mexico women's prison, and that experience shaped her TV drama pilot ROOM OF WONDERS about a jaded teen who uses her growing psychic skills to solve murders alongside her aunt, a free-spirited psychic with a drive-through window.
              </p>
              <p>
                She currently is working on a romantic comedy script about a shy woman who can only talk to attractive men if she's wearing her Santa suit. She's also revising her novel about a burnt-out journalist who quits newspapers to teach in a small southwest town filled with black widows and rattlesnakes…and those are just the people who run the place…
              </p>
              <p>
                Her books: Pamela visited more than 200 wineries for "Guide to American Vineyards," while living in her truck for eight months, driving coast to coast; "Zero Proof," with John Lalich, offers nonalcoholic drink recipes from famous bars and restaurants; and she biked thousands of miles for her two editions of "Short Bike Rides in Michigan."
              </p>
            </div>
          </section>

          {/* Detailed Biography Section */}
          <section className="mb-20">
            <h2 className="text-3xl font-light text-black mb-8 tracking-tight">Pamela Stovall Detailed Biography</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Pamela Stovall is an award-winning screenwriter, writer and author of four books. She has won awards for her full-length features, short scripts and short stories. Her articles and short stories have appeared in numerous national magazines and newspapers.
              </p>
              <p>
                Her scripts have received high honors, such as Top 10 percent in the Austin Film Festival; a Semi-Finalist at Page International Screenwriting Awards; and two scripts won the Spirit of Moondance Award from the Moondance International Film Festival.
              </p>
              <p>
                Stovall's work as a volunteer fire fighter inspired her to write the drama TV pilot FINDING JOY, about a self-destructive female fire chief who's trying to find her missing daughter. FINDING JOY is currently under a shopping agreement with Bohemia Entertainment thanks to an introduction by Roadmap Writers.
              </p>
              <p>
                She also volunteered to teach writing at a New Mexico women's prison, and that experience shaped her TV drama pilot ROOM OF WONDERS about a jaded teen who uses her growing psychic skills to solve murders alongside her aunt.
              </p>
              <p>
                Stovall created, organized and directed Film Boot Camp Gallup, a two-week film camp for high school students at The University of New Mexico Gallup. The camp was made possible by a grant Stovall wrote and was awarded from the State of New Mexico.
              </p>
              <p>
                She taught writing at Girls Film School at the College of Santa Fe. Girls Film School brought female high school students from around the country to Santa Fe to study filmmaking in a two-week intensive.
              </p>
              <p>
                Her books: Pamela visited more than 200 wineries for "Guide to American Vineyards," while living in her truck for eight months, driving coast to coast; "Zero Proof," with John Lalich, offers nonalcoholic drink recipes from famous bars and restaurants; and she biked thousands of miles for her two editions of "Short Bike Rides in Michigan."
              </p>
              <p>
                For the University of New Mexico Gallup, Stovall taught Communication & Journalism as a tenured Associate Professor, and she's taught at various other colleges and universities as well.
              </p>
              <p>
                Stovall has a master's degree in Communication and Journalism from the University of Texas and a bachelor's degree in Political Science/International Relations from the University of Michigan. Stovall also performed graduate work in Mexico City, Mexico.
              </p>
              <p>
                Stovall is currently working on several new projects for film, television and books, including her novel about a burnt-out journalist who quits newspapers to teach in a small southwest town filled with black widows and rattlesnakes…and those are just the people who run the place…
              </p>
            </div>
          </section>

          {/* Published Works Section */}
          <section className="mb-20">
            <h2 className="text-3xl font-light text-black mb-8 tracking-tight">Published Works</h2>
            <div className="space-y-6">
              <div className="border-b border-gray-200 pb-6">
                <h3 className="text-lg font-medium text-black mb-2">Short Bike Rides in Michigan</h3>
                <p className="text-sm text-gray-600 mb-2">Globe Pequot Press • Two Editions</p>
                <p className="text-sm text-gray-700">
                  Comprehensive guide to Michigan's most scenic and accessible cycling routes.
                </p>
              </div>
              <div className="border-b border-gray-200 pb-6">
                <h3 className="text-lg font-medium text-black mb-2">Zero Proof</h3>
                <p className="text-sm text-gray-600 mb-2">St. Martin's Press • Co-authored with John Lalich</p>
                <p className="text-sm text-gray-700">
                  Collaborative work exploring themes of identity and truth.
                </p>
              </div>
              <div className="border-b border-gray-200 pb-6">
                <h3 className="text-lg font-medium text-black mb-2">Guide to American Vineyards</h3>
                <p className="text-sm text-gray-600 mb-2">Globe Pequot Press</p>
                <p className="text-sm text-gray-700">
                  Comprehensive exploration of America's wine regions and vineyards.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-black mb-2">Articles & Short Stories</h3>
                <p className="text-sm text-gray-700">
                  Featured in numerous national magazines and newspapers, showcasing diverse writing across multiple genres and topics.
                </p>
              </div>
            </div>
          </section>

          {/* Screenplay Awards Section */}
          <section className="mb-20">
            <h2 className="text-3xl font-light text-black mb-8 tracking-tight">Screenplay Awards</h2>
            
            {/* The Perfect Cut */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-black mb-4">"The Perfect Cut" - Feature Film Script</h3>
              <ul className="space-y-3">
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Final Round, Top 50 Scripts of almost 4,000 scripts, The Writers Lab, New York Women in Film & Television</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Chosen by BlackShirtReads for a professional screenplay reading at the Jean Cocteau Cinema in Santa Fe, New Mexico</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Austin Film Festival, Top Ten Percent, "Esteemed Second Rounders"</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Moondance International Film Festival, 2011, Winner of the Spirit Award, Feature Screenplays</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Page International Screenwriting Awards, Top Twenty-five Percent, Round Two</span>
                </li>
              </ul>
            </div>

            {/* Crossroads */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-black mb-4">"Crossroads" - Short Script</h3>
              <ul className="space-y-3">
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Moondance International Film Festival, Winner of the Spirit Award, Best Short Screenplay</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Page International Screenwriting Awards, The Top 25 Scripts, Shorts</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Poppy Jasper Film Festival, Winner of the Second Place Award, Best Short Screenplay</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Great Lakes Film Festival, Finalist for Best Short Screenplay</span>
                </li>
              </ul>
            </div>

            {/* Best Served Cold */}
            <div>
              <h3 className="text-xl font-medium text-black mb-4">"Best Served Cold" - Short Script</h3>
              <ul className="space-y-3">
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Golden Brads of Movie Script Short Script Contest, Top 150 Scripts, Best Short Screenplay</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Poppy Jasper Film Festival, Winner of the Third Place Award, Best Short Screenplay</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>American Gem Short Scripts Contest, Top 100 Scripts of 1,200 scripts</span>
                </li>
              </ul>
            </div>

            {/* New Voices New Mexico */}
            <div className="mt-12">
              <h3 className="text-xl font-medium text-black mb-4">New Voices New Mexico 2023</h3>
              <ul className="space-y-3">
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Stowe Story Labs and the New Mexico Film Office</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Chosen Participant, Second Annual Writing Program</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Las Cruces, New Mexico</span>
                </li>
              </ul>
            </div>

            {/* Stagecoach Foundation */}
            <div className="mt-12">
              <h3 className="text-xl font-medium text-black mb-4">Stagecoach Foundation New Mexico</h3>
              <ul className="space-y-3">
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>Screenwriters Conference 2024 Pitch Competition</span>
                </li>
                <li className="text-sm text-gray-700 leading-relaxed flex items-start">
                  <span className="mr-2 mt-1.5 flex-shrink-0">•</span>
                  <span>One of "Top 15 Pitches"</span>
                </li>
              </ul>
            </div>
          </section>

          {/* Education Section */}
          <section className="mb-20">
            <h2 className="text-3xl font-light text-black mb-8 tracking-tight">Education</h2>
            <div className="space-y-6">
              <div className="border-l-2 border-black pl-6">
                <h3 className="text-lg font-medium text-black mb-2">Master's Degree</h3>
                <p className="text-gray-700">Communication & Journalism</p>
                <p className="text-sm text-gray-600">University of Texas</p>
              </div>
              <div className="border-l-2 border-black pl-6">
                <h3 className="text-lg font-medium text-black mb-2">Bachelor's Degree</h3>
                <p className="text-gray-700">Political Science/International Relations</p>
                <p className="text-sm text-gray-600">University of Michigan</p>
              </div>
              <div className="border-l-2 border-black pl-6">
                <h3 className="text-lg font-medium text-black mb-2">Graduate Work</h3>
                <p className="text-gray-700">Advanced Studies</p>
                <p className="text-sm text-gray-600">Mexico City, Mexico</p>
              </div>
            </div>
          </section>

          {/* Teaching & Mentorship Section */}
          <section className="mb-20">
            <h2 className="text-3xl font-light text-black mb-8 tracking-tight">Teaching &amp; Mentorship</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-lg font-medium text-black mb-3">Film Boot Camp Gallup</h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Created, organized and directed a two-week intensive film camp for high school students at The University of New Mexico Gallup, funded by a State of New Mexico grant.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-black mb-3">Girls Film School</h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Taught writing at the College of Santa Fe's intensive two-week program bringing female high school students from across the country to study filmmaking.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-black mb-3">University Teaching</h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Tenured Associate Professor of Communication & Journalism at the University of New Mexico Gallup, with additional teaching positions at various colleges and universities.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-black mb-3">New Mexico Women's Prison</h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Grants, New Mexico. One of four volunteers offering incarcerated women a monthly creative writing program.
                </p>
              </div>
            </div>
          </section>

          {/* Writing Residencies Section */}
          <section className="mb-20">
            <h2 className="text-3xl font-light text-black mb-8 tracking-tight">Writing Residencies</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-lg font-medium text-black mb-3">Hypatia-in-the-Woods</h3>
                <p className="text-sm text-gray-700 leading-relaxed">Residency Award 2021</p>
                <p className="text-sm text-gray-600">Shelton, Washington</p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-black mb-3">Rocaberti Writers Retreat</h3>
                <p className="text-sm text-gray-700 leading-relaxed">Scholarship Winner, 2026</p>
                <p className="text-sm text-gray-600">Sant Mori Castle, Girona, Spain</p>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
